import Swiper, {
  Navigation,
  Pagination
} from 'swiper';

export default class ProductComparisonSlider {

  slideClass = 'jet-listing-grid__item';

  wrapperClass = 'jet-listing-grid__items';

  swiperOptions = {
      modules: [
          Pagination,
          Navigation
      ],
      loop: false,
      slidesPerView: 1.3,
      centeredSlides: true,
      spaceBetween: 10,
      wrapperClass: 'swiper-wrapper',
      slideClass: 'swiper-slide',
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
          el: '.swiper-pagination',
          clickable: true
      },
      breakpoints: {
          768: {
            slidesPerView: 3,
            centeredSlides: false,
            spaceBetween: 33,
            loop: false,
          }
      },
  };

  constructor() {
      this.addEvents();
  }

  addEvents() {
      const swiperElements = document.querySelectorAll('.product-comparison-slider .jet-listing-grid');

      if (!swiperElements) return;


      const that = this;
      window.addEventListener('load', e => {
          setTimeout(() => {
              swiperElements.forEach((swiperElement, index) => {
                  index == 0 ? swiperElement.classList.add('active') : '';
                  // init swiper
                  swiperElement.classList.add('swiper-container');
                  let swiperSlides = swiperElement.querySelectorAll(`.${this.slideClass}`);
                  if(swiperSlides.length > 4 || ( document.body.offsetWidth <= 768 && swiperSlides.length >= 2 ) ) {
                      swiperElement.innerHTML += (`
                      <div class="swiper-button-prev">
                      <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="10.86 12.01 19.39 16.97"> <path d="M29.9375 20.9169L23.0597 28.5733C22.9528 28.6923 22.8235 28.7891 22.6793 28.8581C22.535 28.9271 22.3785 28.967 22.2188 28.9756C22.0591 28.9841 21.8993 28.9612 21.7485 28.9079C21.5976 28.8547 21.4588 28.7723 21.3398 28.6654C21.2208 28.5586 21.1241 28.4293 21.055 28.285C20.986 28.1407 20.9461 27.9843 20.9375 27.8246C20.929 27.6649 20.952 27.5051 21.0052 27.3542C21.0584 27.2034 21.1408 27.0645 21.2477 26.9456L26.1774 21.4705L12.1397 22.2226C11.8185 22.2398 11.5036 22.1287 11.2643 21.9137C11.025 21.6987 10.8809 21.3975 10.8636 21.0763C10.8464 20.755 10.9575 20.4401 11.1725 20.2008C11.3875 19.9615 11.6887 19.8174 12.0099 19.8002L26.0477 19.0482L20.5612 14.1312C20.3209 13.9153 20.1762 13.6128 20.1589 13.2903C20.1416 12.9677 20.2532 12.6515 20.469 12.4113C20.6849 12.171 20.9874 12.0263 21.3099 12.009C21.6324 11.9917 21.9486 12.1033 22.1889 12.3191L29.8454 19.197C29.9649 19.3035 30.0622 19.4326 30.1316 19.5769C30.201 19.7212 30.2412 19.8778 30.2497 20.0377C30.2583 20.1976 30.2351 20.3576 30.1815 20.5085C30.128 20.6594 30.045 20.7982 29.9375 20.9169Z" fill="#262626"></path> </svg>
                      </div>
                          <div class="swiper-button-next">
                          <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="10.86 12.01 19.39 16.97"> <path d="M29.9375 20.9169L23.0597 28.5733C22.9528 28.6923 22.8235 28.7891 22.6793 28.8581C22.535 28.9271 22.3785 28.967 22.2188 28.9756C22.0591 28.9841 21.8993 28.9612 21.7485 28.9079C21.5976 28.8547 21.4588 28.7723 21.3398 28.6654C21.2208 28.5586 21.1241 28.4293 21.055 28.285C20.986 28.1407 20.9461 27.9843 20.9375 27.8246C20.929 27.6649 20.952 27.5051 21.0052 27.3542C21.0584 27.2034 21.1408 27.0645 21.2477 26.9456L26.1774 21.4705L12.1397 22.2226C11.8185 22.2398 11.5036 22.1287 11.2643 21.9137C11.025 21.6987 10.8809 21.3975 10.8636 21.0763C10.8464 20.755 10.9575 20.4401 11.1725 20.2008C11.3875 19.9615 11.6887 19.8174 12.0099 19.8002L26.0477 19.0482L20.5612 14.1312C20.3209 13.9153 20.1762 13.6128 20.1589 13.2903C20.1416 12.9677 20.2532 12.6515 20.469 12.4113C20.6849 12.171 20.9874 12.0263 21.3099 12.009C21.6324 11.9917 21.9486 12.1033 22.1889 12.3191L29.8454 19.197C29.9649 19.3035 30.0622 19.4326 30.1316 19.5769C30.201 19.7212 30.2412 19.8778 30.2497 20.0377C30.2583 20.1976 30.2351 20.3576 30.1815 20.5085C30.128 20.6594 30.045 20.7982 29.9375 20.9169Z" fill="#262626"></path> </svg>
                          </div>
                          <div class="swiper-pagination relative"></div>
                      `);
                  }

                  const swiperWrapper = swiperElement.querySelector(`.${this.wrapperClass}`);
                  swiperWrapper.setAttribute('class', 'swiper-wrapper');

                  if(swiperSlides.length > 1 || ( document.body.offsetWidth <= 768 && swiperSlides.length >= 2 ) ) {
                    swiperWrapper.querySelectorAll(`.${this.slideClass}`).forEach((el) => {
                        el.setAttribute('class', 'swiper-slide');
                    });
                    new Swiper(swiperElement, this.swiperOptions);
                }
              });
          }, 500)

      });
  }

}
